import { gql } from '@apollo/client';
import ErrorResultFragment from "../fragments/ErrorResult";
import OrderGroup from "../fragments/OrderGroup";

const UPDATE_ITEMS_SHOPPING_CART = gql`
  mutation UpdateItems($input: [UpdateItemInput]) {
    shoppingCartContext {
      updateItems(input: $input) {
        errorResult {
          ...ErrorResultFields
        }
        success
        result {
          groups {
            ...OrderGroupFragment
          }
        }
      }
    }
  }
  ${ErrorResultFragment}
  ${OrderGroup}
`;

export default UPDATE_ITEMS_SHOPPING_CART;
